import { Box, Grid, GridItem } from '@chakra-ui/react';
import { useAgenticTriageSettings } from '../../hooks';
import { useEntityAgenticTriageReportContext } from '../../context';
import { EntityInformationPanel } from './EntityInformationPanel';
import { AIAnalysisPanel } from './AIAnalysisPanel';
import { InvestigationFindingsPanel } from './InvestigationFindingsPanel';
import { EntityCommunicationSection } from './EntityCommunicationSection';
import {
  DetectionSummaryInformation,
  DetectionSummaryProvider,
} from '@investigator/features/detections/components';
import { RelatedQuestionsPanel } from './RelatedQuestionsPanel';
import { RecommendedResponsesPanel } from './RecommendedResponsesPanel';

export const EntityOverviewTab = (): JSX.Element => {
  const { agenticTriageEnabled } = useAgenticTriageSettings();
  const { report, isLoading } = useEntityAgenticTriageReportContext();

  // Show two-column layout only if:
  // 1. Agentic triage is enabled AND
  // 2. We have report data (or are still loading it)
  // This ensures full-width layout when no report ID is available
  const showTwoColumnLayout = agenticTriageEnabled && (report || isLoading);

  return (
    <Box pt="15px">
      {showTwoColumnLayout ? (
        <Grid templateColumns={{ base: '1fr', lg: '1fr 1fr' }} gap={4}>
          <GridItem>
            <EntityInformationPanel isFullWidth={false} />
          </GridItem>
          <GridItem>
            <AIAnalysisPanel />
          </GridItem>
        </Grid>
      ) : (
        <EntityInformationPanel isFullWidth={true} />
      )}
      <Box mt={4}>
        <DetectionSummaryProvider>
          <DetectionSummaryInformation />
        </DetectionSummaryProvider>
      </Box>
      <Box mt={4}>
        <InvestigationFindingsPanel />
      </Box>
      <Box mt={4}>
        <EntityCommunicationSection />
      </Box>
      <Box mt={4}>
        <RelatedQuestionsPanel />
      </Box>
      <Box mt={4}>
        <RecommendedResponsesPanel />
      </Box>
    </Box>
  );
};
